export const RETRIEVE_STAFF_CATEGORIES_REQUEST = "RETRIEVE_STAFF_CATEGORIES_REQUEST"
export const RETRIEVE_STAFF_CATEGORIES_SUCCESS = "RETRIEVE_STAFF_CATEGORIES_SUCCESS"
export const RETRIEVE_STAFF_CATEGORIES_FAILURE = "RETRIEVE_STAFF_CATEGORIES_FAILURE"
